import { FC } from "react";
import { Link } from "react-router-dom";
import '../css/navi-menu.css';


interface NaviMenuItemParams {
    id: string;
    title: string;
    link_to: string;
}

export const NaviMenuItem: FC<NaviMenuItemParams> = (params) => {

    return (
        <Link
            // className={`navi-item ${activeItem === params.id ? "navi-item-active" : ""}`}
            className="navi-menu-item"
            to={params.link_to}
        >
            {params.title}
        </Link >
    )
}